import "./shared/styles/fonts.scss";

import LocationMap from "./components/LocationMap/LocationMap.js";
import React from "react";
import ReactDOM from "react-dom";

ReactDOM.render(<LocationMap />, document.getElementById("landing-map"));
